.selectionInfoBanner {
  background-color: var(--bads-color-information-100);
  padding: 6px 16px;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  color: var(--bads-color-text-primary);
  border-bottom: 1px solid var(--bads-color-information-110);
}

.selectionInfoBanner strong {
  margin-right: 6px;
  font-weight: 600;
  color: var(--bads-color-text-primary);
}

.selectionLabel {
  font-weight: 500;
}

.headerContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 8px 10px;
  gap: 0;
  border-bottom: 1px solid var(--bads-color-secondary-110);
  border-top: 1px solid var(--bads-color-secondary-110);
}

.checkboxArea {
  align-items: center;
}

.checkboxWrapper {
  margin-right: 10px;
}

.excitementToggleContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 16px;
  padding-right: 16px;
  position: relative;
  z-index: 20;
}

.toggleContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 16px;
  padding-right: 16px;
  margin-right: 16px;
  border-right: 1px solid var(--bads-color-information-110);
  border-left: 1px solid var(--bads-color-information-110);
  position: relative;
  z-index: 20;
}

.toggleRow {
  margin: 0;
  display: flex;
  justify-content: center;
  text-align: center;
}

.toggleRowLabel {
  display: flex;
  justify-content: center;
  text-align: center;
  white-space: normal;
  word-wrap: break-word;
  max-width: 120px;
  margin-bottom: 3px;
}

.selectShellContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 16px;
  padding-bottom: 3px;
  border-left: 1px solid #ccc;
  position: relative;
  z-index: 20;
}

.selectShellWrapper {
  margin-right: 16px;
}



/* Region dropdown custom rows */
.regionRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 10px;
  cursor: default;
  min-width: 180px;
  gap: 6px;
}

.regionRow:hover {
  background-color: #f5f5f5;
}

.regionIconBtn {
  flex-shrink: 0;
  cursor: pointer;
  padding: 4px;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
}

.regionIconBtn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

.regionLabel {
  flex: 1;
  padding: 0 4px;
  font-size: 14px;
  color: #333;
  white-space: nowrap;
}

.regionLabelDisabled {
  color: #666;
}

.buttonGroupContainer {
  margin-right: auto;
}

/* Make ButtonGroup items text bold */
.buttonGroupContainer :global([class*="bads-button-group-item"]) {
  font-weight: bold !important;
}